import React, { useState, useEffect, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { HalfState } from '../../models/enums/HalfState';
import { useMemo } from 'react';

const CategorizationBar = (props) => {

    const {
        categoriesList,
        selectedCategories,
        setSelectedCategories
    } = props;

    let decrementCategorizationInput = (key) => {
        const selectedCount = selectedCategories[key] ? selectedCategories[key] : 0;
        if (selectedCount && selectedCount > 0) {
            const newSelectedCategories = { ...selectedCategories }
            newSelectedCategories[key] = selectedCount - 1;
            setSelectedCategories(newSelectedCategories);
        }
    }

    let categorizationBar = useMemo(() => {
        if (categoriesList) {
            const categoriesFlat = categoriesList.flatMap(x => x.categories);

            let selectedCategoryKeys = Object.keys(selectedCategories).filter(key => selectedCategories[key] > 0);

            let totalClicks = 0;
            for (let i = 0; i < selectedCategoryKeys.length; i++) {
                let key = selectedCategoryKeys[i];
                totalClicks += selectedCategories[key];
            }


            let output = []

            for (let i = 0; i < selectedCategoryKeys.length; i++) {
                let key = selectedCategoryKeys[i];
                if (selectedCategories[key] > 0) {

                    let categoryClicks = selectedCategories[key];

                    let widthPercentage = categoryClicks / totalClicks * 100;

                    let matchedCategory = categoriesFlat.filter(x => x.id == key)[0];

                    //top left, top right, bottom right, bottom left
                    let radiusMap = ['0', '0', '0', '0'];

                    if (i == 0) {
                        radiusMap[0] = '5px';
                        radiusMap[3] = '5px';
                    }

                    if (i == selectedCategoryKeys.length - 1) {
                        radiusMap[1] = '5px';
                        radiusMap[2] = '5px';
                    }

                    let radiusCssValue = `${radiusMap[0]} ${radiusMap[1]} ${radiusMap[2]} ${radiusMap[3]}`;

                    output.push(
                        <span key={key} style={{
                            width: `${widthPercentage}%`,
                            borderRadius: radiusCssValue
                        }} className='categorizationBarItem'>
                            <a onClick={(event) => { decrementCategorizationInput(key) }} className='categorizationBarButton'>
                                {matchedCategory.name} ({categoryClicks})
                            </a>
                        </span>
                    )
                }
            }

            return <>
                <div className='categorizationBar'>
                    {output}
                </div>


            </>;
        } else {
            return <></>;
        }
    }, [selectedCategories]);

    return (
        <>
            <div
                className="d-flex flex-fill py-1"
                style={{ overflowX: "auto" }}
            >
                {categorizationBar}
            </div>
        </>
    );
}

export default CategorizationBar;
